import { Typography } from '@mui/material'
import { formatBytes } from '../../../../../utils/mimetype'

const Requirements = ({ maxFileSize }) => {
  return (
    <div>
    <Typography color={'primary'} className='font-bold text-lg'>
      Photos requirements:
    </Typography>
    <ul className='text-sm'>
      <li>
        <Typography component={'span'} className='font-bold'>
          File size:
        </Typography>
        <Typography component={'span'} className='px-1 text-muted-foreground text-sm'>
          {formatBytes(maxFileSize, 0)} Maximum per photo.
        </Typography>
      </li>
      <li>
        <Typography component={'span'} className='font-bold'>
          Naming conventions:
        </Typography>
        <Typography component={'span'} className='px-1 text-muted-foreground text-sm'>
          StudentID.jpg, TeacherID.jpg
        </Typography>
      </li>
    </ul>
  </div>
  )
}

export default Requirements